import Image from 'next/image'
import React, { useContext } from 'react'
import { isMobileContext } from '../../contexts/isMobileContext';
import { BASE_URL } from '../../utils/FetchData';

export default function OurPeopleCard({item}) {
	const { isMobile } = useContext(isMobileContext);
  return (
    <div className='people-card'>
        <div className="img-container">
            {item&&<Image
             src={`${BASE_URL}${isMobile?item?.img_mobile.data.attributes?.url:item?.img_desktop.data[0].attributes?.url}`} 
             alt="people_img" 
             layout='fill' 
             objectFit='cover' 
             objectPosition={"top"}
             />}
        </div>
        <div className="details">
            <h4 className="name light">{item?.name}</h4>
            <h6 className="title">{item?.position}</h6>
        </div>
    </div>
  )
}
